import { render, staticRenderFns } from "./PersonalAwayEntitlementTable.vue?vue&type=template&id=53ac71f3&scoped=true&"
import script from "./PersonalAwayEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac71f3",
  null
  
)

export default component.exports